function formatDate(inputDate) { // из формата 1977-08-03 в 03.08.1977
  const parts = inputDate.split("-");
  const year = parts[0];
  const month = parts[1];
  const day = parts[2];

  return `${day}.${month}.${year}`;
}

function reverseFormatDate(dateStr) { // из формата 03.08.1977 в 1977-08-03
  const parts = dateStr.split(".");
  const day = parts[0];
  const month = parts[1];
  const year = parts[2];

  return `${year}-${month}-${day}`;
}

function dateNow() {
  return new Date().toISOString().slice(0, 10);
}

const getMetrikaClientId = () => {
  let yaid = false;
  if (window.ym !== undefined) {
    window.ym(99736562, 'getClientID', function(clientID) {
      yaid = clientID;
    });
  }
  // console.log(window.ym);
  return yaid;
}

export {
  formatDate,
  reverseFormatDate,
  dateNow,
  getMetrikaClientId
};